import React from 'react';
import { RetentionCenter } from './pages/RetentionCenter';
export function App() {
  return <RetentionCenter data-id="element-0" />;
}